import { render } from "./testCart.vue?vue&type=template&id=50a39a4b&scoped=true"
import script from "./testCart.vue?vue&type=script&lang=js"
export * from "./testCart.vue?vue&type=script&lang=js"

import "./testCart.vue?vue&type=style&index=0&id=50a39a4b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a39a4b"]])

export default __exports__